import type { ReactNode } from "react";
import "./MycawanTooltip.scss";
import type { TooltipProps } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

type Properties = TooltipProps;

export default function MycawanTooltip(props: Properties): ReactNode {
  const forwardedProps = {
    ...props,
    children: <div>{props.children}</div>,
    placement: props.placement ?? "top",
    classes: props.classes ?? { tooltip: "mycawan-tooltip-default-style" },
  };

  return <Tooltip {...forwardedProps} />;
}
